import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const IMAGELOGOBLOCK_LEGACY_FIELD_ORDER = [
  "logo",
  "width",
  "bottom_margin"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  imageLogoBlockDescriptor: _generatedImageLogoBlockDescriptor,
  imageLogoBlockBlocDefinition,
  imageLogoBlockDashboardLayout,
  imageLogoBlockConfig,
  imageLogoBlockResolveConfig,
  imageLogoBlockProperties,
} = doodBlockConfig(
  {
    name: "Image logo",
    componentType: 'ImageLogoBlockComponent',
    category: 'media',
    description: "Image logo.",
    keywords: [],
    allowed_in: ["GenericPage"],
    sharedFields: {}
  },

  () => ({
    logo: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.image-logo.logo.label",
        help: "pages.blocks.image-logo.logo.help",
      }
    }),
    width: propertyValue({
      type: 'select',
      value: "Logo size",
      options: {
        label: "pages.blocks.image-logo.width.label",
        choices: [
          {
            value: "small",
            label: "pages.blocks.image-logo.width.options.small",
          },
          {
            value: "medium",
            label: "pages.blocks.image-logo.width.options.medium",
          },
          {
            value: "large",
            label: "pages.blocks.image-logo.width.options.large",
          },
          {
            value: "full",
            label: "pages.blocks.image-logo.width.options.full",
          },
        ],
      }
    }),
    bottom_margin: propertyValue({
      type: 'select',
      value: "medium",
      options: {
        label: "pages.blocks.image-logo.bottom-margin.label",
        choices: [
          {
            value: "none",
            label: "pages.blocks.image-logo.bottom-margin.options.none",
          },
          {
            value: "small",
            label: "pages.blocks.image-logo.bottom-margin.options.small",
          },
          {
            value: "medium",
            label: "pages.blocks.image-logo.bottom-margin.options.medium",
          },
          {
            value: "large",
            label: "pages.blocks.image-logo.bottom-margin.options.large",
          },
        ],
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.image-logo.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.image-logo.fieldset.logo.label",
            fields: ["logo", "width", "bottom_margin"],
          },
        ],
      },
    ],
  })
);

export function imageLogoBlockDescriptor(): IBlockDescriptor;
export function imageLogoBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function imageLogoBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedImageLogoBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedImageLogoBlockDescriptor, imageLogoBlockProperties, fieldOrder);
}

export {
  imageLogoBlockBlocDefinition,
  imageLogoBlockDashboardLayout,
  imageLogoBlockProperties,
  imageLogoBlockConfig,
  imageLogoBlockResolveConfig,
};

export type ImageLogoBlockConfig = typeof imageLogoBlockConfig;
